// extracted by mini-css-extract-plugin
module.exports = {"gradientFirst":"#5ab9ea","gradientSecond":"#718bdc","card":"Card_card__39xAa","card__inner":"Card_card__inner__nz_Dq","card_list":"Card_card_list__3L2TL"};